<template>
	<div>
		<div style="display: flex;align-items: center;justify-content: space-between;">
			<a-breadcrumb style="margin: 16px 0">
				<a-breadcrumb-item>主页</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectFirstMenu}}</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectSecondMenu}}</a-breadcrumb-item>
				<a-breadcrumb-item>{{checkstationName}}</a-breadcrumb-item>
			</a-breadcrumb>
			<div>
                <a-button class="qinang-button-margin" icon="plus" @click="addVisible = true">新增</a-button>
				<a-button class="qinang-button-margin" icon="edit" @click="tableEdit">修改</a-button>
				<a-button class="qinang-button-margin" icon="delete" @click="tableDel">删除</a-button>
				<a-button icon="sync" @click="apiCorrelationQueryList">刷新</a-button>
			</div>
		</div>
		
		<a-collapse expandIconPosition="right" activeKey="1">
			<a-collapse-panel key="1" header="园门关联查询">
				<div style="display: flex;justify-content: space-between;">
					<div style="width: 30%;display: flex;align-items: center;">
						<div style="width: 120px;">关联类型：</div>
                        <a-select v-model="query.correlationType" placeholder="请选择关联类型" style="width: 100%;">
                            <a-select-option v-for="item in correlationTypeList" :key="item.value" :value="item.value">{{item.label}}</a-select-option>
                        </a-select>
					</div>
					<div style="width: 30%;display: flex;align-items: center;justify-content: flex-end;">
						<a-button type="primary" icon="search" @click="apiCorrelationQueryList">查询</a-button>
					</div>
				</div>
			</a-collapse-panel>
		</a-collapse>
		
		<div class="qinang-card">
            <div style="display: flex;justify-content: space-between;align-items: center;">
				<a-breadcrumb separator=">" style="padding: 12.5px 16px;" >
					<a-breadcrumb-item>
						{{checkstationName}}
					</a-breadcrumb-item>
				</a-breadcrumb>
				<a-tooltip placement="bottomRight">
					<template slot="title">
					  <span>返回上一级</span>
					</template>
					<a-button type="link" @click="backMainNavigation"><i class="icon-sjp-fanhui"></i></a-button>
				</a-tooltip>
			</div>
			<a-table :row-selection="rowSelection" :columns="tableColumns" :data-source="tableData" row-key="checkstationCorrelationId" :loading="tableLoading" :pagination="false">
				<span slot="masterCheckstationId" slot-scope="masterCheckstationId">
					{{checkstationName}}
				</span>
				<span slot="subCheckstationId" slot-scope="subCheckstationId">
					{{checkstationList.find(item => item.checkstationId == subCheckstationId.subCheckstationId).checkstationName}}
				</span>
                <span slot="correlationType" slot-scope="correlationType">
					{{correlationTypeList.find(item => item.value == correlationType.correlationType).label}}
				</span>
				<span slot="checkstationCorrelationState" slot-scope="checkstationCorrelationState">
					<span v-if="checkstationCorrelationState == 2">禁用</span>
					<span v-if="checkstationCorrelationState == 3">正常</span>
				</span>
			</a-table>
			<a-pagination style="text-align: right;margin: 10px;" :current="query.page" :total="query.total" :default-page-size="query.size" show-size-changer show-quick-jumper size="small" :page-size-options="['10', '20', '50']"
				:show-total="total => `共 ${total} 条记录`" @change="pageChange" @showSizeChange="showSizeChange"/>
		</div>

		<!-- 添加弹窗 -->		
		<a-modal title="添加关联" width="60%" :visible="addVisible" :confirm-loading="addConfirmLoading" @ok="addHandleOk" @cancel="addVisible = false" :maskClosable="false" :keyboard="false" >
			<a-form-model style="" ref="addRuleForm" :model="addForm" :label-col="{span: 4}" :wrapper-col="{span: 18}" :rules="addRules">
				<a-form-model-item label="主园门" has-feedback >
					<span>{{checkstationName}}</span>
				</a-form-model-item>
				<a-form-model-item label="关联园门" has-feedback  prop="subCheckstationId">
					<a-select v-model="addForm.subCheckstationId" placeholder="请选择关联园门" >
						<a-select-option v-for="(item,index) in checkstationList" :value="item.checkstationId" :key="index">{{item.checkstationName}}</a-select-option>
					</a-select>
				</a-form-model-item>
				<a-form-model-item label="关联类型" has-feedback  prop="correlationType">
					<a-select v-model="addForm.correlationType" placeholder="请选择关联类型" >
						<a-select-option v-for="item in correlationTypeList" :key="item.value" :value="item.value">{{item.label}}</a-select-option>
					</a-select>
				</a-form-model-item>
				<a-form-model-item label="是否启用" has-feedback prop="checkstationCorrelationState">
					<a-radio-group name="checkstationCorrelationState" v-model="addForm.checkstationCorrelationState">
						<a-radio :value="3">是</a-radio>
						<a-radio :value="2">否</a-radio>
					</a-radio-group>
				</a-form-model-item>
				<a-form-model-item label="备注" has-feedback prop="remark">
					<a-textarea placeholder="在这里输入备注" :rows="4" v-model="addForm.remark" />
				</a-form-model-item>
			</a-form-model>
		</a-modal>
		
		<!-- 修改弹窗 -->
		<a-modal title="修改关联" width="60%" :visible="editVisible" :confirm-loading="editConfirmLoading" @ok="editHandleOk" @cancel="editVisible = false"  :maskClosable="false" :keyboard="false">
			<a-form-model style="" ref="editRuleForm" :model="editForm" :label-col="{span: 4}" :wrapper-col="{span: 18}" :rules="addRules">
				<a-form-model-item label="主园门" has-feedback prop="masterCheckstationId">
					<span>{{checkstationName}}</span>
				</a-form-model-item>
				<a-form-model-item label="关联园门" has-feedback  prop="subCheckstationId">
					<a-select v-model="editForm.subCheckstationId" placeholder="请选择关联园门" disabled >
						<a-select-option v-for="(item,index) in checkstationList" :value="item.checkstationId" :key="index">{{item.checkstationName}}</a-select-option>
					</a-select>
				</a-form-model-item>
				<a-form-model-item label="关联类型" has-feedback prop="correlationType">
					<a-select v-model="editForm.correlationType" placeholder="请选择关联类型" >
						<a-select-option v-for="item in correlationTypeList" :key="item.value" :value="item.value">{{item.label}}</a-select-option>
					</a-select>
				</a-form-model-item>
				<a-form-model-item label="是否启用" has-feedback prop="checkstationCorrelationState">
					<a-radio-group name="checkstationCorrelationState" v-model="editForm.checkstationCorrelationState">
						<a-radio :value="3">是</a-radio>
						<a-radio :value="2">否</a-radio>
					</a-radio-group>
				</a-form-model-item>
				<a-form-model-item label="备注" has-feedback prop="remark">
					<a-textarea placeholder="在这里输入备注" :rows="4" v-model="editForm.remark" />
				</a-form-model-item>
			</a-form-model>
		</a-modal>
	</div>
</template>

<script>
	import moment from 'moment'
	export default {
		data() {
			return {
				moment,
				selectFirstMenu: window.sessionStorage.getItem('selectFirstMenu'),
				selectSecondMenu: window.sessionStorage.getItem('selectSecondMenu'),
				checkstationName: this.$route.query.checkstationName || '园门关联',
                checkstationId: this.$route.query.checkstationId || '',
                facilitatorId: this.$route.query.facilitatorId || '',
                correlationTypeList: [
                    {
                        label: '互斥关联',
                        value: 2
                    },
                    {
                        label: '同检关联',
                        value: 3
                    }
                ],
				// 搜索+表格-start
				query: {
					page: 1,
					size: 10,
					total: 0,
					correlationType: undefined,
					masterCheckstationId: this.$route.query.checkstationId || '',
				},
				tableData: [],
				tableColumns: [
					{ title:'ID', dataIndex:'checkstationCorrelationId', key:'checkstationCorrelationId', align:'center'},
					{ title:'主园门', key:'masterCheckstationId', align:'center', scopedSlots:{customRender:'masterCheckstationId'}},
					{ title:'关联园门', key:'subCheckstationId', align:'center', scopedSlots:{customRender:'subCheckstationId'}},
                    { title:'关联类型', key:'correlationType', align:'center', scopedSlots:{customRender:'correlationType'}},
					{ title:'状态', dataIndex:'checkstationCorrelationState', key:'checkstationCorrelationState', align:'center', scopedSlots:{customRender:'checkstationCorrelationState'}},
                    { title:'备注', dataIndex:'remark', key:'remark', align:'center'},
				],
				tableLoading: false,
				tableSelectedRows: {},
				tableSelectedRowKeys:[], // 批量选中的key
				//搜索+表格-end
				// 添加弹窗-start
				addVisible: false,
				addConfirmLoading: false,
				addForm: {
					masterCheckstationId: '',
					subCheckstationId: undefined,
					correlationType: undefined,
					checkstationCorrelationState: 3,
					remark: '',
				},
				addRules: {
					// masterCheckstationId: [{ required: true, message: '请选择主园门', trigger: 'blur' }],
					subCheckstationId: [{ required: true, message: '请选择关联园门', trigger: 'blur' }],
					correlationType: [{ required: true, message: '请选择关联类型', trigger: 'blur' }],
				},
				// 添加弹窗-end
				// 修改弹窗-start
				editVisible: false,
				editConfirmLoading: false,
				editForm: {
					id: '',
					masterCheckstationId: '',
					subCheckstationId: '',
					correlationType: '',
					checkstationCorrelationState: 3,
					remark: '',
				},
				// 修改弹窗-end
				checkstationList: [], //园门列表
			};
		},
		methods: {
			//表格开始-搜索
			async apiCorrelationQueryList() {
				this.tableLoading = true
				const {
					data: res
				} = await this.$http.post(this.navigation.apiCheckstationCorrelationQueryList, this.query);
				if (res.code == 200) {
					this.tableData = res.data.list
					this.query.page = res.data.pages.page
					this.query.size = res.data.pages.size
					this.query.total = res.data.pages.total
					this.tableLoading = false
					this.tableSelectedRows = {}
					this.tableSelectedRowKeys = []
				} else {
					this.$message.error(res.msg)
					this.tableLoading = false
				}
			},
			pageChange(page, pageSize){
				this.query.page = page
				this.query.size = pageSize
				this.apiCorrelationQueryList()
			},
			showSizeChange(current, size){
				this.query.page = current
				this.query.size = size
				this.apiCorrelationQueryList()
			},

			//获取园门列表
			async apiCheckstationList() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiCheckstationList, {facilitatorId: this.facilitatorId});
				if (res.code == 200) {
                    let checkstationList = []
                    res.data.forEach(item => {
                        if(this.checkstationId != item.checkstationId){
                        checkstationList.push({
                            checkstationId: item.checkstationId,
                            checkstationName: item.checkstationName
                        })
                    }
                    })
                    
					this.checkstationList = checkstationList
				} else {
					this.$message.error(res.msg)
				}
			},

			//添加关联
			async apiCorrelationAdd() {
                this.addForm.masterCheckstationId = this.checkstationId
                this.addForm.facilitatorId = this.facilitatorId
				const {
					data: res
				} = await this.$http.post(this.navigation.apiCheckstationCorrelationAdd, this.addForm);
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.$refs.addRuleForm.resetFields();
					this.apiCorrelationQueryList()
					this.addConfirmLoading = false
					this.addVisible = false
				} else {
					this.$message.error(res.msg)
					this.addConfirmLoading = false
				}
			},
			addHandleOk() {
				this.$refs.addRuleForm.validate(valid => {
					if (valid) {
						this.apiCorrelationAdd()
					} else {
					  return false;
						this.addConfirmLoading = true
					}
				});
				
			},
			//添加弹窗事件-结束
			//修改弹窗事件-开始
			edit(item){
				let items = JSON.parse(JSON.stringify(item))
                items.correlationType = parseInt(items.correlationType)
                console.log(items)
				this.editForm = items
                console.log(this.editForm)
				this.editVisible = true
			},
			async apiCorrelationEdit() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiCheckstationCorrelationEdit, this.editForm);
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.$refs.editRuleForm.resetFields();
					this.apiCorrelationQueryList()
					this.editConfirmLoading = false
					this.editVisible = false
				} else {
					this.$message.error(res.msg)
					this.editConfirmLoading = false
				}
			},
			
			editHandleOk() {
				this.$refs.editRuleForm.validate(valid => {
					if (valid) {
						this.apiCorrelationEdit()
					} else {
					  return false;
						this.editConfirmLoading = true
					}
				});
				
			},
			//修改弹窗事件-结束
			//删除
			tableDel() {
				let that = this
				if(this.tableSelectedRows.checkstationCorrelationId > 0) {
					this.$confirm({
						title: '确定要删除当前选中数据吗',
						content: '删除后将无法恢复',
						okText: '确定',
						okType: 'danger',
						cancelText: '取消',
						onOk() {
							that.apiCorrelationDelete()
						},
						onCancel() {
						},
					});
				}else{
					this.$message.warning('请选择要删除的数据');
				}
			},
			//删除
			async apiCorrelationDelete() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiCheckstationCorrelationDel+'/'+ this.tableSelectedRows.checkstationCorrelationId);
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.apiCorrelationQueryList()
				} else {
					this.$message.error(res.msg)
				}
			},

			tableEdit() {
				if(this.tableSelectedRows.checkstationCorrelationId > 0) {
					this.edit(this.tableSelectedRows)
				}else{
					this.$message.warning('请选择要修改的数据');
				}
			},
            backMainNavigation(){
                this.$router.push({
                    path: '/CheckStation',
                    query: {
                        facilitatorId: this.facilitatorId
                    }
                })
            }
			
		},
		computed: {
			rowSelection() {
				let that = this
				return {
					type: 'radio',
					selectedRowKeys: that.tableSelectedRowKeys,
					onChange: (selectedRowKeys, selectedRows) => {
						that.tableSelectedRows = selectedRows[0]
						that.tableSelectedRowKeys = selectedRowKeys
					},
				};
			},
		
		},
		created() {
			this.apiCheckstationList()
			this.apiCorrelationQueryList()
		}
	};
</script>

<style scoped>
	
</style>